var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('users',{ref:"users",attrs:{"account-id":_vm.agencyId}},[_c('invite-user-btn',{staticClass:"q-mb-md",attrs:{"account-id":_vm.agencyId,"color":"primary","label":"Add CM Reports System User"},on:{"invited":_vm.unshift}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }